import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { formatLocDateMMDDYYYY } from '@mummssoftware/utils/formatters';
import { styles } from '../../utils/styles';
import defaults from '../../translations/en.json';
export const PrintFooterPDFComponent = props => /*#__PURE__*/React.createElement(View, {
  fixed: true,
  style: styles.pageFooter
}, /*#__PURE__*/React.createElement(View, {
  style: [styles.row, styles.justifyContentBetween]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerSubHeader
}, `${defaults.printedOn} `, formatLocDateMMDDYYYY(new Date())), /*#__PURE__*/React.createElement(Text, {
  style: styles.printerSubHeader,
  render: ({
    pageNumber,
    totalPages
  }) => `${defaults.page} ${pageNumber} ${defaults.of} ${totalPages}`
})));